@import '../../../constants/spacing.module.less';

.freight-settings-page {
  padding: @space-24;

  &__header {
    margin-bottom: @space-24;
  }

  &__providers {
    max-width: 800px;
  }
}

.provider-card {
  border: 1px solid var(--grey-300);
  border-radius: @space-8;
  padding: @space-16;

  &__status {
    &--connected {
      color: var(--green-600);
    }

    &--disconnected {
      color: var(--grey-600);
    }
  }
}
